module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('multiselect', {
    attrs: {
      "select-label": "",
      "options": _vm.suggestions,
      "custom-label": _vm.label,
      "track-by": "id",
      "loading": _vm.isLoading,
      "multiple": _vm.multiple,
      "hideSelected": true,
      "placeholder": _vm.placeholder,
      "allow-empty": true
    },
    on: {
      "search-change": _vm.searchUser,
      "input": _vm.update,
      "select": _vm.select
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "item"
        }, [_c('dp', {
          attrs: {
            "who": props.option
          }
        }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(props.option.firstname) + " " + _vm._s(props.option.lastname))])], 1)]
      }
    }]),
    model: {
      value: (_vm.cur_value),
      callback: function($$v) {
        _vm.cur_value = $$v
      },
      expression: "cur_value"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("\n        " + _vm._s(_vm.noResultText) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a6ac118","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-select.vue
// module id = 102
// module chunks = 0 1